module.exports = __webpack_public_path__ + "static/media/re.4477ebd1.png";